import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../button"

const LogoutConfirmationModal = ({ isLogoutModalOpen, closeLogoutModal, logout }) => {
  return (
    <Modal
      show={isLogoutModalOpen}
      onHide={closeLogoutModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Log Out</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>Are you sure you want to log out?</div>
      </Modal.Body>
      <Modal.Footer>
        <Button text="Yes" callBack={logout} />
        <Button text="No" callBack={closeLogoutModal} />
      </Modal.Footer>
    </Modal>
  );
};

export default LogoutConfirmationModal;
